import { IconSvgProps } from '../types';

export const Keyhole = ({ size }: IconSvgProps) => (
  <svg
    id="icon-object-keyhole"
    width={size}
    height={size}
    viewBox="0 0 65 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <rect
          fillRule="nonzero"
          opacity="0.5"
          transform="translate(32.040000, 32.980000) rotate(90.000000) translate(-32.040000, -32.980000) "
          x="0.04"
          y="0.98"
          width="64"
          height="64"
          rx="32"
        />
        <path d="M64.04,32.98 C64.04,15.31 49.71,0.98 32.04,0.98 C14.36,0.98 0.04,15.31 0.04,32.98 C0.04,50.66 14.36,64.98 32.04,64.98 C49.71,64.98 64.04,50.66 64.04,32.98 Z M28.48,33.42 C24.97,32.01 22.49,28.58 22.49,24.56 C22.49,19.29 26.77,15.02 32.04,15.02 C37.31,15.02 41.58,19.29 41.58,24.56 C41.58,28.39 39.33,31.69 36.07,33.21 L42.35,47.71 C42.78,48.71 42.05,49.83 40.96,49.83 L23.68,49.83 C22.59,49.83 21.85,48.71 22.29,47.71 L28.48,33.42 Z" />
      </g>
    </g>
  </svg>
);
